import { FormattedMessage } from "react-intl";

import { Result } from "antd";

export const ForbiddenPage = () => {
  return (
    <Result
      status={"403"}
      title={
        <FormattedMessage
          id="error.forbidden.title"
          defaultMessage="Error 403"
        />
      }
      subTitle={
        <FormattedMessage
          id="error.forbidden.sub_title"
          defaultMessage="Sorry, you are not authorized to access this website."
        />
      }
    />
  );
};
